import { render, staticRenderFns } from "./SuccessPayment.vue?vue&type=template&id=42e84ac4"
import script from "./SuccessPayment.vue?vue&type=script&lang=js"
export * from "./SuccessPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports